import { render, staticRenderFns } from "./MarketingDialog.vue?vue&type=template&id=4f7060ee"
import script from "./MarketingDialog.vue?vue&type=script&lang=js"
export * from "./MarketingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports